import(/* webpackMode: "eager", webpackExports: ["GoogleOAuthProvider"] */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/@react-oauth/google/dist/index.esm.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next-axiom/dist/webVitals/components.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["BottomCookie"] */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/cookie/BottomCookie.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/workspace/bravve-independent-station-web_jyzf/src/lib/antd-registry.tsx");
